export default {
  displayName: 'Temperature Range',
  allowableParents: ['Section'],
};
